var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6376 12.5837V7.92577C15.6376 5.08182 13.6596 2.70145 11.0048 2.08091C11.0109 2.02803 11.0208 1.97624 11.0208 1.92172C11.0208 1.15553 10.3997 0.534424 9.63353 0.534424C8.86734 0.534424 8.24624 1.15553 8.24624 1.92172C8.24624 1.97624 8.25617 2.02803 8.26228 2.08091C5.60744 2.70145 3.62947 5.08182 3.62947 7.92577V12.5837L1.84665 15.3326C1.6887 15.5762 1.86349 15.8979 2.15379 15.8979H17.1133C17.4036 15.8979 17.5784 15.5762 17.4204 15.3326L15.6376 12.5837Z",
    fill: "#3B84E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08046 1.06861L4.35858 0C1.75231 1.76101 0.196289 4.68762 0.196289 7.82887H1.48596C1.48596 5.11662 2.82976 2.58926 5.08046 1.06861Z",
    fill: "#3B84E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 0L14.1162 1.06861C16.3669 2.58926 17.7107 5.11662 17.7107 7.82887H19.0004C19.0004 4.68762 17.4444 1.76101 14.8381 0Z",
    fill: "#3B84E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6336 20C11.1539 20 12.3863 18.7676 12.3863 17.2473H6.88086C6.88086 18.7676 8.11331 20 9.6336 20Z",
    fill: "#3B84E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.6b2d74ae5793e38d7d132e66b1063ffa.svg";
export { ForwardRef as ReactComponent };